import React from 'react'
import { asset } from '../../../helpers/dom.helper'
import '../styles/Benefits_style.css'
import IconWithLabel from './IconWithLabel'

export default function Benefits({ data, title }) {

  return (
    <div className="benefits__container" >
      <p className="benefits__title">{title}</p>
      <div className="icons__container" id="wrap__box">
        <IconWithLabel icon={asset('/images/career/7_days.webp')} label={data[0].title} />
        <IconWithLabel icon={asset('/images/career/unlimited.webp')} label={data[1].title} />
        <IconWithLabel icon={asset('/images/career/company.webp')} label={data[2].title} />
        <IconWithLabel icon={asset('/images/career/guarantee.webp')} label={data[3].title} />
        {/* </span> */}
      </div>
      {/* </div> */}
    </div>
  )

}
